import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements AfterViewInit {

  @ViewChild('header') header: ElementRef;

  @Output('onClickFeatures') onClickFeatures = new EventEmitter();
  @Output('onClickDetails') onClickDetails = new EventEmitter();
  @Output('onClickConcept') onClickConcept = new EventEmitter();
  @Output('onClickOpportunities') onClickOpportunities = new EventEmitter();

  @Input('features') features: HTMLElement;
  @Input('details') details: HTMLElement;
  @Input('concept') concept: HTMLElement;
  @Input('opportunities') opportunities: HTMLElement;
  @Input('footer') footer: HTMLElement;

  showHamburgurMenu = window.innerWidth < 600;
  activeSection?: string;

  constructor(
    public router: Router
  ) { }

  ngAfterViewInit(): void {
    const sticky = this.header.nativeElement.offsetTop;
    window.onscroll = () => {
      if (window.pageYOffset > sticky) {
        this.header.nativeElement.classList.add("sticky");
      } else {
        this.header.nativeElement.classList.remove("sticky");
      }
    };
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize($event: any) {
    this.showHamburgurMenu = window.innerWidth < 600;
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event: any) {
    if (this.features && this.details && this.concept && this.opportunities && this.footer) {

      // features
      if (window.scrollY >= this.features.offsetTop && window.scrollY < this.details.offsetTop) {
        this.activeSection = "features";
      }
      // details
      if (window.scrollY >= this.details.offsetTop && window.scrollY < this.concept.offsetTop) {
        this.activeSection = "details";
      }
      // concept
      if (window.scrollY >= this.concept.offsetTop && window.scrollY < this.opportunities.offsetTop) {
        this.activeSection = "concept";
      }
      // opportunities
      if (window.scrollY >= this.opportunities.offsetTop && window.scrollY < this.footer.offsetTop) {
        this.activeSection = "opportunities";
      }
      // none
      if (window.scrollY < this.features.offsetTop || window.scrollY > this.footer.offsetTop) {
        this.activeSection = undefined;
      }
      
    }else{
      this.activeSection = undefined;
    }
  }

}
